(function () {
  'use strict';
  var source = document.currentScript.dataset.legacySrc;
  var pending = false;
  var observer;
  function load() {
    if (pending) return;
    pending = true;
    var script = document.createElement('script');
    script.src = source;
    script.async = true;
    script.onload = function () { if (observer) observer.disconnect(); };
    script.onerror = function () {
      pending = false;
      script.remove();
    };
    document.head.appendChild(script);
  }
  function hasTarget(node) {
    return node.nodeType === 1 &&
      (node.matches('.lazyloadt4s') || node.querySelector('.lazyloadt4s'));
  }
  if (window.MutationObserver) {
    observer = new window.MutationObserver(function (mutations) {
      if (pending) return;
      for (var i = 0; i < mutations.length; i++) {
        var mutation = mutations[i];
        if (mutation.type === 'attributes') {
          if (mutation.target.matches('.lazyloadt4s')) { load(); return; }
        } else {
          for (var j = 0; j < mutation.addedNodes.length; j++) {
            if (hasTarget(mutation.addedNodes[j])) { load(); return; }
          }
        }
      }
    });
    observer.observe(document.documentElement, {
      childList: true, subtree: true, attributes: true, attributeFilter: ['class']
    });
    if (document.querySelector('.lazyloadt4s')) load();
  } else load();
})();
